
export const calculateTotals = (items) => {
    return items.reduce((acc, item) => {
        acc.grossTotal += parseFloat(item.line_amount) || 0;
        acc.discountTotal += parseFloat(item.header_discount) || 0;
        acc.vatAmount += parseFloat(item.vat_amount) || 0;
        acc.netTotal += parseFloat(item.amount_incl_vat) || 0;
        return acc;
    }, {
        grossTotal: 0,
        discountTotal: 0,
        vatAmount: 0,
        netTotal: 0
    });
};